/* eslint-disable */
export const spritesheets = {
  ".spritesheet-cache": {
    hd: {
      json: "./.spritesheet-cache.json",
    },
  },
  "background": {
    hd: {
      json: ["./background-1.json", "./background-2.json"],
      png: ["./background-1.png", "./background-2.png"],
      webp: ["./background-1.webp", "./background-2.webp"],
      avif: ["./background-1.avif", "./background-2.avif"],
    },
    sd: {
      json: "./background@0.5x.json",
      png: "./background@0.5x.png",
      webp: "./background@0.5x.webp",
      avif: "./background@0.5x.avif",
    },
  },
  "buybonus": {
    hd: {
      json: "./buybonus.json",
      png: "./buybonus.png",
      webp: "./buybonus.webp",
      avif: "./buybonus.avif",
    },
    sd: {
      json: "./buybonus@0.5x.json",
      png: "./buybonus@0.5x.png",
      webp: "./buybonus@0.5x.webp",
      avif: "./buybonus@0.5x.avif",
    },
  },
  "freespins": {
    hd: {
      json: "./freespins.json",
      png: "./freespins.png",
      webp: "./freespins.webp",
      avif: "./freespins.avif",
    },
    sd: {
      json: "./freespins@0.5x.json",
      png: "./freespins@0.5x.png",
      webp: "./freespins@0.5x.webp",
      avif: "./freespins@0.5x.avif",
    },
  },
  "gamble": {
    hd: {
      json: "./gamble.json",
      png: "./gamble.png",
    },
    sd: {
      json: "./gamble.json",
      png: "./gamble.png",
    },
  },
  "multipliers": {
    hd: {
      json: "./multipliers.json",
      png: "./multipliers.png",
      webp: "./multipliers.webp",
      avif: "./multipliers.avif",
    },
    sd: {
      json: "./multipliers@0.5x.json",
      png: "./multipliers@0.5x.png",
      webp: "./multipliers@0.5x.webp",
      avif: "./multipliers@0.5x.avif",
    },
  },
  "newpanel": {
    hd: {
      json: "./newpanel.json",
      png: "./newpanel.png",
      webp: "./newpanel.webp",
      avif: "./newpanel.avif",
    },
    sd: {
      json: "./newpanel@0.5x.json",
      png: "./newpanel@0.5x.png",
      webp: "./newpanel@0.5x.webp",
      avif: "./newpanel@0.5x.avif",
    },
  },
  "popupsf": {
    hd: {
      json: "./popupsf.json",
      png: "./popupsf.png",
      webp: "./popupsf.webp",
      avif: "./popupsf.avif",
    },
    sd: {
      json: "./popupsf@0.5x.json",
      png: "./popupsf@0.5x.png",
      webp: "./popupsf@0.5x.webp",
      avif: "./popupsf@0.5x.avif",
    },
  },
  "reels": {
    hd: {
      json: "./reels.json",
      png: "./reels.png",
      webp: "./reels.webp",
      avif: "./reels.avif",
    },
    sd: {
      json: "./reels@0.5x.json",
      png: "./reels@0.5x.png",
      webp: "./reels@0.5x.webp",
      avif: "./reels@0.5x.avif",
    },
  },
  "splash_screen": {
    hd: {
      json: ["./splash_screen-1.json", "./splash_screen-2.json"],
      png: ["./splash_screen-1.png", "./splash_screen-2.png"],
      webp: ["./splash_screen-1.webp", "./splash_screen-2.webp"],
      avif: ["./splash_screen-1.avif", "./splash_screen-2.avif"],
    },
    sd: {
      json: "./splash_screen@0.5x.json",
      png: "./splash_screen@0.5x.png",
      webp: "./splash_screen@0.5x.webp",
      avif: "./splash_screen@0.5x.avif",
    },
  },
  "symbols": {
    hd: {
      json: "./symbols.json",
      png: "./symbols.png",
      webp: "./symbols.webp",
      avif: "./symbols.avif",
    },
    sd: {
      json: "./symbols@0.5x.json",
      png: "./symbols@0.5x.png",
      webp: "./symbols@0.5x.webp",
      avif: "./symbols@0.5x.avif",
    },
  },
};
